module.exports = __webpack_public_path__ + "static/media/visa.56eee586.svg";